module.exports = __webpack_public_path__ + "vue_assets/img/img_app_preview_mac.6233eb71.png";